import { IAction, IComData } from "@/common/interface";
import { SET_COM_DATA } from "../actionTypes";

const initState: IComData = {
  adspaces: {},
};

export default (state = initState, action: IAction): IComData => {
  switch (action.type) {
    case SET_COM_DATA:
      return { ...action.data };
    default:
      return state;
  }
};

// export default combineReducers({
//   comData
// });
